import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const FrameType = iotsUtils.fromList(constants.job.hitlv2.frame.frameTypes);
